import React, {Fragment, useEffect, useRef, useState} from 'react';
import {InputSaveEdit, Spinner} from "../../../shared";
import {FormattedMessage, useIntl} from "react-intl";
import {formatFileSize, getFileName, isOnlyMobileDevice} from "../../../../utils/utils";
import InputSelectList from "../../../shared/inputSelectList/inputSelectList";
import group from "../../../group";
import {useSelector} from "react-redux";
import GroupCard from "../../../group/groupCard/groupCard";
import functions from "../../../../utils/functionsFirebase";

function ShareFileForm({file, allGroups, onClose}) {

    const intl = useIntl();

    useEffect(() => {
        setTitle(getFileName(file.fileName));
        setDescription("");
        setLoading(false);
        setPublished(false);
    }, [file])

    const [title, setTitle] = useState(getFileName(file.fileName));
    const [description, setDescription] = useState("");
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [published, setPublished] = useState(false);

    const closeModalButton = useRef();

    async function publishFile() {
        setLoading(true);
        const shareFileWithGroups = functions.httpsCallable('shareFileWithGroups');
        await shareFileWithGroups({fileId: file.id, groupIds: groups.map(x => x.id), title, description});
        setLoading(false);
        setPublished(true);
    }

    if (published) {
        return (
            <div>
                <div>
                    <h4><FormattedMessage id="file-viewer.publish-file.finished-title"/></h4>
                    <hr/>
                    <button ref={closeModalButton} type="button" style={{display: 'none'}}
                            data-bs-dismiss="modal">Close
                    </button>

                    <small>
                        <FormattedMessage
                            id="file-viewer.publish-file.finished-info"
                            values={{
                                fileName: file.fileName
                            }}/>
                    </small>
                    <div className="mt-2">
                        {groups.map(group => {
                            return <GroupCard key={group.id} group={group} joined={true}
                                              onClick={() => {
                                                  onClose?.();
                                                  closeModalButton.current.click()
                                              }}/>
                        })}
                    </div>
                    <div>
                        <button type="button" className="btn btn-secondary"
                                onClick={() => {
                                    setPublished(false);
                                    setGroups([]);
                                }}>
                            <FormattedMessage id="file-viewer.publish-file.reload-form"/>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    if (loading) {
        return (
            <div>
                <h4><FormattedMessage id="file-viewer.publish-file.form-title"/></h4>
                <hr/>
                <div className="d-flex justify-content-center flex-row flex-wrap">
                    <Spinner/>
                    <small className="col-12 text-center">
                        <FormattedMessage
                            id="file-viewer.publish-file.upload-info.wait"
                            values={{
                                fileName: file.fileName
                            }}/>
                    </small>
                </div>
            </div>
        )
    }

    return (
        <div>
            <h4><FormattedMessage id="file-viewer.publish-file.form-title"/></h4>
            <hr/>
            {!allGroups && <Spinner/>}
            {allGroups?.length > 0 &&
                <Fragment>
                    <InputSaveEdit alwaysEditing={true} onSave={value => setTitle(value)} inputValue={title}
                                   maxLength={30}
                                   label={intl.formatMessage({id: "file-viewer.publish-file.form.title"})}/>
                    <div className="mt-3"></div>
                    <InputSaveEdit alwaysEditing={true} onSave={value => setDescription(value)} inputValue={description}
                                   required={false} maxLength={400}
                                   label={intl.formatMessage({id: "file-viewer.publish-file.form.description"})}
                                   textArea={{
                                       placeHolder: intl.formatMessage({id: "file-viewer.publish-file.form.description-placeholder"})
                                   }}/>
                    <div className="mt-1"></div>
                    <InputSelectList options={allGroups} optionsLabel="groupName" optionsIcon="photoUrl"
                                     result={groups} setResult={setGroups}
                                     placeholder={intl.formatMessage({id: "group-search.title"})}
                                     label={intl.formatMessage({id: "file-viewer.publish-file.form.select-groups"})}/>
                    <div className="text-end">
                        <small><FormattedMessage id="file-viewer.publish-file.form.selected-groups"/>{groups.length}</small>
                    </div>
                </Fragment>}
            {allGroups?.length === 0 &&
                <div>
                    <div className="alert alert-danger d-flex align-items-center" style={{height: 'auto'}}
                         role="alert">
                        <FormattedMessage id="file-viewer.publish-file.form.no-valid-groups"/>
                    </div>
                </div>}

            <div className="col-12 mt-4 d-flex justify-content-between">
                <button type="button" className="btn btn-danger"
                        data-bs-toggle="collapse" data-bs-target="#collapseShareFileForm"
                        aria-expanded="false" aria-controls="collapseShareFileForm" onClick={() => onClose?.()}>
                    <FormattedMessage id="modal.cancel"/>
                    <i className="fa-solid fa-ban ms-2"></i>
                </button>
                {allGroups?.length > 0 &&<button type="button" className="btn btn-success"
                        disabled={!title || title == "" || groups.length === 0}
                        onClick={publishFile}>
                    <FormattedMessage id="file-viewer.publish-file"/>
                    <i className="fa-solid fa-users ms-2"></i>
                </button>}
            </div>

        </div>
    )

}

export default ShareFileForm;
